import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["element"]

  elementTargetConnected(element) {
    let block = element.dataset.block || "start"

    element.scrollIntoView({ behavior: "smooth", block: block })
    setTimeout(() => {
      element.scrollIntoView({ behavior: "smooth", block: block })
    }, 1000)
  }

  scrollToLoading() {
    const anchor = document.getElementById("loading")
    anchor.scrollIntoView({ behavior: "smooth", block: "end" })
  }

}
